<div class="main-content config-workbook">
  <div class="main-header">Config Workbook <div class="tooltip"><img src="./assets/Info.svg" alt="Image 1" />
      <div class="tooltiptext">Generate config workbook.</div>
    </div> <a class="t-r t-x" style="cursor: pointer;" (click)="getWorkbookCsvPage()"><span
        style="cursor: pointer;"><img style="vertical-align: middle; margin-right:5px;"
          src="./assets/Convert.svg" alt="convert workbook to csv ">Convert Workbook to CSV Extract</span></a>
    <span class="t-r" style="cursor: pointer;">
      <img style="vertical-align: middle; margin-right: 16px;" src="./assets/Home.svg" [routerLink]="['']"
        [queryParams]="isTrainStopUrl? queryParams: ''" (click)="maskPage()" alt="Home"></span>
  </div>

  <div class="" style="margin-top: 47px;">
    <div>
      <div class="section ">
        <div class="content">
          <div class="sub-text-600">Select Extract Batch Key</div>
          <div class="search-container">
            <div class="search-content">
              <input type="search" name="searchText" autocomplete="off" (keyup.enter)="search(searchText)"
                (input)="searchOnInput($event.target.value)" [(ngModel)]="searchText" placeholder="Search Batch Key"
                class="search" />
              <button [disabled]="!searchText" (click)="search(searchText)" mat-flat-button class="green-button"
                style="width:95px; margin-left: 24px;">Search</button>
            </div>
            <div class="refresh-container">
              <a style="cursor: hand; cursor:pointer" *ngIf="extractRefresh === true && dataSourceWorkBook.filteredData.length > 0" (click)="onRefresh()"><img
                  src="./assets/Refresh.svg" alt="refresh"></a>
            </div>
          </div>

          <div *ngIf="extractFromCloudData.length>0">
            <div class="table-wrapper">
              <div class="table-container">
                <table aria-label="convert workbook to csv extract table">
                  <thead>
                    <th class="w-7">
                      Select
                    </th>
                    <th class="w-30">
                      Batch Key
                    </th>
                    <th class="w-20" *ngFor="let filter of filterSelectObj; let i=index;">
                      <span> {{filter.name}} </span>
                      <select class="select-css" [(ngModel)]="filter.modelValue"
                        (change)="filterChange(filter,$event,i)">
                        <option *ngFor="let item of filter.options; let i=index" [value]="item">{{item}}</option>
                      </select>
                    </th>
                    <th class="w-15">
                      Date
                    </th>
                    <th class="extractStatus w-28">
                      Extraction Status
                    </th>
                  </thead>
                  <tr *ngIf="dataSourceWorkBook.filteredData.length == 0">
                    <td colspan="5"><span class="recordstext">No records found</span></td>
                  </tr>
                </table>
              </div>
              <div style="border: 5px solid rgba(208, 208, 206, 0.35);">
                <table mat-table matSort
                  [dataSource]="tableData |  paginate: { itemsPerPage: size, currentPage: p, totalItems: dataSourceWorkBook.filteredData.length}"
                  style="text-align: left;" aria-hidden="true">
                  <ng-container matColumnDef="check_box">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-7 select-extract'">
                      <mat-checkbox type="Checkbox" (change)="onChange($event,element)" [checked]="checked(element)">
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="batch_key">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-30'">
                      <a class="projectId extractBatchKey" (click)="onBatchKeyClick(element.batch_key,element,'extracts')">{{element.batch_key}}</a>
                      <a class="details-info"><img title="Config Details" src="./assets/details_Info.svg" alt="Image 1" (click)="modulePopUp(element.batch_key,element.module)"/></a></td>
                  </ng-container>
                  <ng-container matColumnDef="extract_source">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-20'"> {{element.source_type}}</td>
                  </ng-container>
                  <ng-container matColumnDef="date">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-15'"> {{element.creation_date | date
                      :'dd/MM/yyyy'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-28 extractStatus'">
                      <span>{{element.extract_status}}</span>
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
              </div>
              <div class="pagenation-container" *ngIf="dataSourceWorkBook.filteredData.length>5">
                <table aria-label="convert workbook to csv extract table pagination controls">
                  <thead>
                    <th>
                      <pagination-controls (pageChange)="p = $event;paginate(p)"></pagination-controls>
                    </th>
                  </thead>
                </table>
              </div>
            </div>
          </div>


          <div *ngIf="failedToFetchBatchKeys" class="empty-container">
            <div>
              <img src="./assets/Not Found.svg" alt="Not-Found">
            </div>
            <div class="empty-container-content">
              <span>Something went wrong!</span>
              <button (click)="getExtractBatchKeys()" mat-flat-button class="green-button">Try Again</button>
            </div>
          </div>

          <div *ngIf="noExtractsFound" class="empty-container">
            <div>
              <img src="./assets/Not Found.svg" alt="Not-Found">
            </div>
            <div class="empty-container-content">
              <span>No extracts yet!
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
          </div>

          <div class="create-workbook" style="    padding-bottom: 40px; border-bottom: 1px solid rgba(0,0,0,.12);"
            *ngIf="!noExtractsFound && !failedToFetchBatchKeys">
            <div>
              <button mat-flat-button [disabled]="workbookNewBtnDisable" class="green-button mt32" style="width:145px;"
                (click)="onSubmit1()"> Create Workbook </button>

            </div>
          </div>

          <div class="sub-text-600" style="margin-top: 60px;">Config Workbook</div>
          <div class="search-container">
            <div class="search-content">
              <input type="search" name="searchText1" autocomplete="off" (keyup.enter)="searchForWorkbook(searchText1)"
                (input)="searchOnInput1($event.target.value)" [(ngModel)]="searchText1" placeholder="Search Batch Key"
                class="search" />
              <button [disabled]="!searchText1" mat-flat-button class="green-button"
                (click)="searchForWorkbook(searchText1)" style="width:95px; margin-left: 24px;">Search</button>
            </div>
            <div class="refresh-container">
              <a style="cursor: hand; cursor:pointer" *ngIf="refresh === true && dataSourceConfigWorkBook.filteredData.length > 0" (click)="onRefreshForWorkbook()"><img
                  src="./assets/Refresh.svg" alt="refresh"></a>
            </div>
          </div>
          <div *ngIf="extractionBatchKeys.length>0" #scrollToMe>
            <div class="table-wrapper">
              <div class="table-container">
                <table aria-label="Config Workbook table">
                  <thead>
                    <th class="w-25">
                      Batch Key
                    </th>
                    <th class="w-15">
                      Date

                    </th>
                    <th class="w-30" *ngFor="let filter of filterSelectObjForWorkbook; let i=index;">
                      <span> {{filter.name}} </span>
                      <select class="select-css" [(ngModel)]="filter.modelValue"
                        (change)="filterChange1(filter,$event,i)">
                        <option *ngFor="let item of filter.options; let i=index" [value]="item">{{item}}</option>
                      </select>
                    </th>
                    <th class="action w-30">
                      Action
                    </th>
                  </thead>
                  <tr *ngIf="dataSourceConfigWorkBook.filteredData.length == 0">
                    <td colspan="5"><span class="recordstext">No records found</span></td>
                  </tr>
                </table>
              </div>
              <div style="border: 5px solid rgba(208, 208, 206, 0.35);">
                <table mat-table matSort
                  [dataSource]="tableData1 |  paginate: { id: 'portingTnPagination', itemsPerPage: size, currentPage: p1, totalItems: dataSourceConfigWorkBook.filteredData.length}"
                  style="text-align: left;" aria-hidden="true">
                  <ng-container matColumnDef="batch_key">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-25'"> <a class="projectId"
                        (click)="onBatchKeyClick(element.batch_key,element,'workbooks')">{{element.batch_key}}</a>
                        <a class="details-info"><img title="Config Details" src="./assets/details_Info.svg" alt="Image 1" (click)="modulePopUp(element.batch_key,element.module)"/></a></td>
                  </ng-container>
                  <ng-container matColumnDef="date">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-15'"> {{element.creation_date | date
                      :'dd/MM/yyyy'}}</td>
                  </ng-container>
                  <ng-container matColumnDef="workbook_status">
                    <td mat-cell *matCellDef="let element" [ngClass]="'w-30'"> {{element.workbook_status}}</td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <td mat-cell *matCellDef="let element; index as i" [ngClass]="'w-30 action'">
                      <img
                        *ngIf="element.workbook_status === 'Config Workbook - In Progress' || element.workbook_status === 'Config Workbook - Process Submitted'"
                        src="./assets/Download-Disabled.svg" alt="Download-Disabled"><img style="cursor: pointer;"
                        (click)="getDownloadDropdown(i)"
                        *ngIf="element.workbook_status === 'Config Workbook - Error' || element.workbook_status === 'Bot Fail'"
                        src="./assets/Download.svg" alt="Download"><img
                        *ngIf="element.workbook_status === 'Config Workbook - Complete' || element.workbook_status === 'Config Workbook - Completed'"
                        style="cursor: pointer;" (click)="getDownloadDropdown(i)" src="./assets/Download.svg" alt="Download">
                      <article *ngIf="hideme ===i" (window:mouseup)="autoCloseForDropdownCars($event)"
                        style="position: relative;">
                        <article class="shadow-bg download-enhancement">
                          <ul class="clearfix list-f m0 list-pn download-list">
                            <li *ngIf="element.downloadAll" (click)="downloadFiles(element.module, element.batch_key)">
                              Download All
                              <img alt=""
                                src="./assets/Download.svg"
                                style="vertical-align: middle; float: right; cursor: pointer;">
                            </li>
                            <li class="active" *ngFor="let item1 of element.module"><span
                                [ngClass]="item1.application == 'Error' ? 'red-t' : ''">{{item1.application}} </span>
                              <span *ngIf="item1.application !=='Error'">
                                ({{item1.success_count}}/{{item1.total_count}})</span>
                              <img
                                *ngIf="(item1.success_count ===0 && item1.application !=='Error') || (item1.application === 'Error' && (!item1.output_file_path || !item1.fileList.length))"
                                src="./assets/Download-Disabled.svg" alt="Download-Disabled"
                                style="vertical-align: middle; float: right; cursor: pointer;">
                              <img
                                *ngIf="(item1.application ==='Error' && item1.output_file_path && item1.fileList.length) || (item1.success_count !=0 && item1.application !=='Error')"
                                (click)="downloadFiles(item1, element.batch_key)" src="./assets/Download.svg" alt="Download"
                                style="vertical-align: middle; float: right; cursor: pointer;">
                            </li>
                          </ul>
                        </article>

                      </article>
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsForWorkbook;"></tr>
                </table>
              </div>
              <div class="pagenation-container" *ngIf="dataSourceConfigWorkBook.filteredData.length>5">
                <table aria-label="Config Workbook pagination controls">
                  <thead>
                    <th>
                      <pagination-controls id="portingTnPagination" (click)="getRefresh()"
                        (pageChange)="p1 = $event;paginate1(p1)">
                      </pagination-controls>
                    </th>
                  </thead>
                </table>
              </div>
            </div>
          </div>
          <div *ngIf="failedToFetchWorkbooks" class="empty-container">
            <div>
              <img src="./assets/Not Found.svg" alt="Not-Found">
            </div>
            <div class="empty-container-content">
              <span>Something went wrong!</span>
              <button (click)="getWorkbookBatchkeys()" mat-flat-button class="green-button">Try Again</button>
            </div>
          </div>
          <div *ngIf="noWorkbooksCreated" class="empty-container">
            <div>
              <img src="./assets/Not Found.svg" alt="Not-Found">
            </div>
            <div class="empty-container-content">
              <span>No Config Workbook Yet!</span>
              <button mat-flat-button [disabled]="workbookNewBtnDisable" class="green-button create-workbook-button"
                (click)="onSubmit1()">Create Workbook</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
